import { Provider } from "react-redux";
import { Toaster } from "sonner";
import MainNavigation from "./router";
import { store } from "./store";
import { ThemeProvider } from "./contexts/ThemeContext";
// import ThemeToggle from "./components/ThemeToggle/ThemeToggle";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Toaster position="top-right" />
        <MainNavigation />
        {/* <ThemeToggle /> */}
      </ThemeProvider>
    </Provider>
  );
}

export default App;
